import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Box, Typography, TextField, Paper, Chip, Autocomplete, Collapse, Button } from "@mui/material";
import { Filter } from "iconsax-react";


const Filters = observer(({ uiStore, searchFilters, updateFilters, clear, search }) => {
    const [filters, setFilters] = useState([]);
    const [advanced, setAdvanced] = useState(false);
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);


    const updateAddressFilters = async (type, value, name) => {
        if (type === 'country') {
            setCountry(value)
            setState('')
            setCity('')

            if (!value)
                return setStateOptions([]);

            const options = [];

            searchFilters['Address'].forEach((info) => {
                if (info?.country === value)
                    if (info?.state && !options.includes(info?.state))
                        options.push(info?.state);
            });

            setStateOptions(options);
        } else if (type === 'state') {
            setState(value);
            setCity('')

            if (!value)
                return setCityOptions([]);

            const options = [];

            searchFilters['Address'].forEach((info) => {
                if (info?.country === country && info?.state === value)
                    if (info?.city && !options.includes(info?.city))
                        options.push(info?.city);
            });

            setCityOptions(options);
        } else {
            setCity(value)
        }

        handleChangeFilter(name, [value]);
    }

    useEffect(() => {

        async function initFilters() {
            var filters = [];

            filters = [
                { name: "Country", value: [], type: "select", options: [], advanced: false },
                { name: "State / Province", value: [], type: "select", options: [], advanced: true },
                { name: "City", value: [], type: "select", options: [], advanced: true },
                { name: "Company", value: [], type: "select", options: [], advanced: true },
                { name: "Job Title", value: [], type: "select", options: [], advanced: true },
                { name: "Department", value: [], type: "select", options: [], advanced: true },
            ];

            if (searchFilters) {
                for (let i = 0; i < filters.length; i++) {
                    filters[i].options = [...filters[i].options]

                    searchFilters[filters[i].name]?.forEach((info) => {
                        if (info.multipleValues) {
                            info.infoValues.forEach(item => {
                                if (!filters[i].options.includes(item))
                                    filters[i].options.push(item);
                            })
                        } else {
                            if (!filters[i].options.includes(info.infoValue))
                                filters[i].options.push(info.infoValue);
                        }
                    });
                }

                searchFilters['Address']?.forEach((info) => {
                    if (info?.country) {
                        if (!filters[0].options.includes(info?.country)) {
                            filters[0].options.push(info?.country);
                        }
                    }

                    if (info?.state) {
                        if (!filters[1].options.includes(info.state))
                            filters[1].options.push(info.state);
                    }

                    if (info?.city) {
                        if (!filters[2].options.includes(info.city))
                            filters[2].options.push(info.city);
                    }
                })

                setStateOptions(filters[1].options)
                setCityOptions(filters[2].options)
            }
            setFilters(filters);
        }

        initFilters();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFilters]);

    const handleChangeFilter = (filterName, value) => {
        const index = filters.findIndex(filter => filter.name === filterName);
        const clone = JSON.parse(JSON.stringify(filters));

        if (clone[index])
            clone[index].value = value;
        setFilters(clone);
        updateFilters(clone);
    }

    const clearFilters = () => {
        const clone = [...filters];
        clone.forEach(element => {
            element.value = [];
            setCountry('')
            setState('')
            setCity('')
        });

        setFilters(clone);
        updateFilters(clone);
        if (clear)
            clear();
    };

    return (

        <Paper variant="round" sx={{ p: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }} >
                <Box sx={{ display: 'flex' }}>
                    <Filter
                        size="24"
                        variant="Bulk"
                    />
                    <Typography fontWeight={600} sx={{ ml: 1 }}>Filters</Typography>
                </Box>
                <Button fontSize={14} onClick={clearFilters}>CLEAR</Button>
            </Box>

            {filters.length &&
                <Box sx={{ mt: 3 }}>
                    <Autocomplete
                        sx={{ mt: 3 }}
                        renderInput={(params) => <TextField label={filters[0].name} {...params} />}
                        disablePortal
                        options={filters[0]?.options || []}
                        size='small'
                        onChange={(e, value) => updateAddressFilters('country', value, filters[0].name)}
                        value={country}
                    />

                    {!!country &&
                        <Autocomplete
                            sx={{ mt: 3 }}
                            renderInput={(params) => <TextField label={filters[1].name} {...params} />}
                            disablePortal
                            options={stateOptions.length > 0 ? stateOptions : filters[1]?.options || []}
                            size='small'
                            onChange={(e, value) => updateAddressFilters('state', value, filters[1].name)}
                            value={state}
                        />
                    }

                    {!!state &&
                        <Autocomplete
                            sx={{ mt: 3 }}
                            renderInput={(params) => <TextField label={filters[2].name} {...params} />}
                            disablePortal
                            options={cityOptions.length > 0 ? cityOptions : filters[2]?.options || []}
                            size='small'
                            onChange={(e, value) => updateAddressFilters('city', value, filters[2].name)}
                            value={city}
                        />
                    }


                    {filters?.filter(i => !i.advanced)?.map(filter =>
                        'Country' !== filter.name &&
                        <Box key={filter.name}>
                            {filter.type === 'single' &&
                                <>
                                    <Typography fontWeight={600} fontSize='14px'>Show Contacts</Typography>
                                    <Chip
                                        variant={filter.value.includes('All') ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='All'
                                        onClick={() => handleChangeFilter(filter.name, ['All'])}
                                    />
                                    <Chip
                                        variant={filter.value.includes("n'Sync") ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label="n'Sync"
                                        onClick={() => handleChangeFilter(filter.name, ["n'Sync"])}
                                    />
                                    <Chip
                                        variant={filter.value.includes('Following') ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='Added'
                                        onClick={() => handleChangeFilter(filter.name, ['Following'])}
                                    />
                                </>
                            }

                            {filter.type === 'multiple' &&
                                <Autocomplete
                                    multiple
                                    sx={{ mt: 3 }}
                                    renderInput={(params) => <TextField label='Tags' {...params} />}
                                    disablePortal
                                    options={filter.options}
                                    size='small'
                                    onChange={(e, value) => handleChangeFilter(filter.name, value)}
                                    value={filter.value}
                                />
                            }

                            {filter.type === 'select' &&
                                <Autocomplete
                                    sx={{ mt: 3 }}
                                    renderInput={(params) => <TextField label={filter.name} {...params} />}
                                    disablePortal
                                    options={filter.options}
                                    size='small'
                                    onChange={(e, value) => handleChangeFilter(filter.name, [value])}
                                    value={filter.value[0]}
                                />
                            }

                        </Box>
                    )}

                    <Collapse in={advanced}>
                        {filters?.filter(i => i.advanced)?.map(filter =>
                            !['State / Province', 'City'].includes(filter.name) &&
                            < Autocomplete
                                key={filter.name}
                                sx={{ mt: 3 }}
                                renderInput={(params) => <TextField label={filter.name} {...params} />}
                                disablePortal
                                options={filter.options}
                                size='small'
                                onChange={(e, value) => handleChangeFilter(filter.name, [value])}
                                value={filter.value[0]}
                            />
                        )}
                    </Collapse>

                </Box>
            }

            <Box sx={{ mt: 3 }}>
                <Button onClick={() => setAdvanced(val => !val)} fontSize={14}> {!advanced ? 'Show Advanced' : 'Hide Advanced'}</Button>
            </Box>


            <Box onClick={search} sx={{textAlign: 'right'}}>
                <Button variant='contained' size='large'>Apply</Button>
            </Box>

        </Paper>
    );
});

export default Filters;